module.exports = __webpack_public_path__ + "static/media/phone_touch_icon.2ae64551.png";